import { ModalWindow } from '@cian/ui-kit';

import * as React from 'react';

import { ErrorContent } from '../../components/ErrorContent';
import { LoadingContent } from '../../components/LoadingContent';
import { useContext } from '../../utils/useContext';

import { AVAILABLE_STATUS_LIST, TITLE_MAPPING } from './constants';

export const FallbackModalContainer: React.FC = () => {
  const context = useContext();

  const content = React.useMemo(() => {
    switch (context.status) {
      case 'loading': {
        return <LoadingContent />;
      }
      case 'failed': {
        const { onOpen } = context;

        return <ErrorContent onRetry={onOpen} />;
      }
      default:
        return null;
    }
  }, [context]);

  if (!AVAILABLE_STATUS_LIST.includes(context.status)) {
    return null;
  }

  return (
    <ModalWindow
      fixed
      content={content}
      escape={false}
      maxWidth={540}
      open={context.open}
      size="M"
      title={TITLE_MAPPING[context.status]}
      width="100%"
      onClose={context.onClose}
    />
  );
};
